import { dapvApi } from 'services/providers/dapv';
import { ApiResponse } from 'services/providers/dapv.types';
import {
    EmailAuthLoginPayload,
    EmailAuthLoginResponse,
    ForgotPasswordPayload,
    ForgotPasswordResponse,
    PhoneAuthLoginBypassResponse,
    PhoneAuthLoginPayload,
    PhoneAuthLoginResponse,
    PhoneConfirmationAuthLoginPayload,
    PhoneConfirmationAuthLoginResponse,
    ResetPasswordPayload,
    ResetPasswordResponse
} from './auth.types';

const authApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        emailAuthLogin: build.mutation<ApiResponse<EmailAuthLoginResponse>, EmailAuthLoginPayload>({
            query: ({ email, password }: EmailAuthLoginPayload) => {
                return {
                    url: '/core/auth/login',
                    method: 'POST',
                    body: { email, password }
                };
            },
            transformResponse: (response: ApiResponse<EmailAuthLoginResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        phoneAuthLogin: build.mutation<ApiResponse<PhoneAuthLoginResponse>, PhoneAuthLoginPayload>({
            query: ({ phone }: PhoneAuthLoginPayload) => {
                return {
                    url: '/core/auth/sms/send',
                    method: 'POST',
                    body: { phone }
                };
            },
            transformResponse: (response: ApiResponse<PhoneAuthLoginResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        phoneAuthLoginBypass: build.mutation<ApiResponse<PhoneAuthLoginBypassResponse>, PhoneAuthLoginPayload>({
            query: ({ phone }: PhoneAuthLoginPayload) => {
                return {
                    url: '/core/auth/phone/login',
                    method: 'POST',
                    body: { phone }
                };
            },
            transformResponse: (response: ApiResponse<PhoneAuthLoginBypassResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        phoneConfirmationAuthLogin: build.mutation<ApiResponse<PhoneConfirmationAuthLoginResponse>, PhoneConfirmationAuthLoginPayload>({
            query: ({ phone, code }: PhoneConfirmationAuthLoginPayload) => {
                return {
                    url: '/core/auth/sms/check',
                    method: 'POST',
                    body: { phone, code }
                };
            },
            transformResponse: (response: ApiResponse<PhoneConfirmationAuthLoginResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        forgotPassword: build.mutation<ApiResponse<ForgotPasswordResponse>, ForgotPasswordPayload>({
            query: ({ email }: ForgotPasswordPayload) => {
                return {
                    url: '/core/auth/forgot-password',
                    method: 'POST',
                    body: { email }
                };
            },
            transformResponse: (response: ApiResponse<ForgotPasswordResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        resetPassword: build.mutation<ApiResponse<ResetPasswordResponse>, ResetPasswordPayload>({
            query: ({ token, password, confirm_password }: ResetPasswordPayload) => {
                return {
                    url: '/core/auth/reset-password',
                    method: 'POST',
                    body: { token, password, confirm_password }
                };
            },
            transformResponse: (response: ApiResponse<ResetPasswordResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useEmailAuthLoginMutation,
    usePhoneAuthLoginMutation,
    usePhoneAuthLoginBypassMutation,
    usePhoneConfirmationAuthLoginMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation
} = authApi;
